import React from "react";
import styles from "./styles.less";

const OptimaStripes = () => (
  <div className={styles.topLineColor}>
    <ul className={styles.stripeList}>
      {Array(5)
        .fill()
        .map((_, i) => <li key={i} />)}
    </ul>
  </div>
);

export default OptimaStripes;



// WEBPACK FOOTER //
// ./src/components/common/OptimaStripes/OptimaStripes.js